<template>
  <ThePage :title="i18n(translations.title)">
    <template #pageTitle>
      {{ i18n(translations.title) }}
    </template>
    <template #pageActions>
      <div class="flex flex-col md:flex-row md:space-x-12">
        <RevButton
          class="hidden md:flex"
          data-qa="import-drawer-button"
          variant="secondary"
          @click="handleImport"
        >
          {{ i18n(translations.actionImport) }}
        </RevButton>
        <RevButton
          class="hidden md:flex"
          data-qa="export-drawer-button"
          variant="secondary"
          @click="handleExport"
        >
          {{ i18n(translations.actionExport) }}
        </RevButton>
        <RevButton
          data-qa="create-backship-label"
          full-width="adaptive"
          :to="{ name: ROUTE_NAMES.SHIPPING.CREATE_LABEL }"
          variant="secondary"
        >
          {{ i18n(translations.actionCreateBackShipLabel) }}
        </RevButton>

        <ImportDrawer />
        <ExportDrawer />
      </div>
    </template>
    <template #pageContent>
      <NavTabs
        :index-route-name="ROUTE_NAMES.ORDERS.INDEX"
        :label="translations.navigation"
        :withLabelSuffix
      />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { getMerchantOrdersMetadata } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants-orders/merchant-orders-page'
import type { GetMerchantOrdersMetadata } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants-orders/merchant-orders-pages.types'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { openModal } from '@ds/components/ModalBase'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './Index.translations'
import { MODAL_NAME as EXPORT_DRAWER } from './components/ExportDrawer/ExportDrawer.constants'
import ExportDrawer from './components/ExportDrawer/ExportDrawer.vue'
import { MODAL_NAME as IMPORT_DRAWER } from './components/ImportDrawer/ImportDrawer.constants'
import ImportDrawer from './components/ImportDrawer/ImportDrawer.vue'

const i18n = useI18n()

const { data } = useHttpFetch(getMerchantOrdersMetadata)

function getBadgeCount(
  presetCounterCode: GetMerchantOrdersMetadata['presetCounters'][0]['code'],
) {
  return (
    data.value?.presetCounters.find(({ code }) => code === presetCounterCode)
      ?.count || 0
  )
}

function withLabelSuffix(routeName: string): number {
  if (routeName === ROUTE_NAMES.ORDERS.TABS.NEW) {
    return getBadgeCount('NEW')
  }

  if (routeName === ROUTE_NAMES.ORDERS.TABS.PENDING) {
    return getBadgeCount('PENDING')
  }

  if (routeName === ROUTE_NAMES.ORDERS.TABS.PENDING) {
    return getBadgeCount('NEEDING_RESPONSE')
  }

  return 0
}

function handleImport() {
  openModal(IMPORT_DRAWER)
}
function handleExport() {
  openModal(EXPORT_DRAWER)
}
</script>
